import {
  Icons,
  LabelChipV2,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

export const OptimizationStateItem = ({
  prev,
  curr,
  label,
  policyName,
}: {
  prev: boolean;
  curr: boolean;
  label: string;
  policyName?: string;
}) => {
  const chipProps = (state: boolean) =>
    state
      ? { label: 'Optim. on' as const, color: 'blue' as const }
      : { label: 'Optim. off' as const, color: 'grey' as const };

  return (
    <Stack direction="row" alignItems="center" gap={8}>
      <Typography variant="L10M">{label}</Typography>
      {policyName && <Typography variant="P10R">{policyName}</Typography>}
      <LabelChipV2 size="s" {...chipProps(prev)} />
      {prev !== curr && (
        <>
          <Icons.ArrowRight color={tokens.theme.fg.structural.secondary} />{' '}
          <LabelChipV2 size="s" {...chipProps(curr)} />
        </>
      )}
    </Stack>
  );
};
